import { Avatar, AvatarGroup } from "@chakra-ui/react";
import { AVATAR_URL } from "utils/constants";

const ContactsTableCell = ({ contacts }: { contacts: any[] }) => {
  return (
    <AvatarGroup size="md" max={3}>
      {contacts.map((contact: any) => (
        <Avatar
          width="40px"
          height="40px"
          key={contact.id}
          src={`${AVATAR_URL}${contact.user.id}`}
          name={`${contact.user.first_name} ${contact.user.last_name}`}
        />
      ))}
    </AvatarGroup>
  );
};

export default ContactsTableCell;
